module.exports = __webpack_public_path__ + "static/media/sauna.ced815c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/sauna.svg
// module id = 1538
// module chunks = 0